import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { ResponseModel } from 'src/app/shared/models/response.model';

@Injectable({
    providedIn:'root'
})
export class FileGroupAssignmentService{
    private url:string;

    constructor(private http:HttpClient){
    this.url=environment.api;
        //this.url=environment.apiIq09;
    }

    public assignmnet(userId:number):Observable<ResponseModel>{
        var headers = new HttpHeaders().set('content-Type', 'application/x-www-form-urlencoded');
        return this.http.get<ResponseModel>(this.url+'FileGroupAssignment/assignment/'+userId,{headers:headers});
    }
}